<template>
  <div class="negocio-filter-container bg-[var(--fundoForm)] p-4 rounded-lg shadow-lg">
    <!-- Filter Header -->
    <div class="flex items-center justify-between mb-4">
      <h3 class="text-[var(--text)] font-semibold">Filtros do Produto</h3>
      <div class="flex items-center gap-3">
        <button
          @click="clearFilters"
          class="text-blue-400 hover:text-blue-300 text-sm underline"
        >
          Limpar Filtros
        </button>
        <button
          @click="closeFilter"
          class="text-gray-400 hover:text-[var(--text)] text-lg transition-colors"
          title="Fechar filtros"
        >
          <i class="fa-solid fa-times"></i>
        </button>
      </div>
    </div>

   
    <!-- Search Fields -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 mt-4">

      <div class="filter-group">
        <label class="filter-label">Produto</label>
        <input
          v-model="filters.produto_search"
          type="text"
          placeholder="Ex: Nome do produto..."
          @input="onFilterChange"
          class="filter-input"
        />
      </div>

      <div class="filter-group">
        <label class="filter-label">Descrição</label>
        <input
          v-model="filters.descricao_search"
          type="text"
          placeholder="Ex: Descrição da instalação..."
          @input="onFilterChange"
          class="filter-input"
        />
      </div>

      <div class="filter-group">
        <label class="filter-label">Familia</label>
        <select
          v-model="filters.familia_id"
          @change="onFilterChange"
          class="filter-input"
        >
          <option value="">Selecione uma familia...</option>
          <option
            v-for="option in familiaOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>
      

      <div class="filter-group">
        <label class="filter-label">Estado</label>
        <select
          v-model="filters.status"
          @change="onFilterChange"
          class="filter-input"
        >
          <option value="">Selecione um estado...</option>
          <option
            v-for="option in statusOptions"
            :key="option.value"
            :value="option.value"
          >
            {{ option.label }}
          </option>
        </select>
      </div>

      <div class="filter-group">
        <label class="filter-label">Tipo</label>
        <select
          v-model="filters.tipo_filter"
          @change="onFilterChange"
          class="filter-input"
        >
          <option value="">Todos os tipos...</option>
          <option value="equipamento">Equipamento</option>
          <option value="acessorio">Acessório</option>
          <option value="independente">Independente</option>
        </select>
      </div>

    </div>
    <!-- Apply Filters Button -->
    <div class="flex justify-end mt-4">
      <button
        @click="applyFilters"
        class="px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
      >
        Aplicar Filtros
      </button>
    </div>

  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.css'

// Props
const props = defineProps({
  allowedStatuses: {
    type: Array,
    default: null // null means all statuses allowed
  },
  defaultStatus: {
    type: String,
    default: null // default status when "all" is selected
  },
  restrictToStatuses: {
    type: Array,
    default: null // Backend restriction - only return these statuses
  }
})

// Emits
const emit = defineEmits(['filtersChanged', 'close-filter'])

// Filter state
const filters = ref({
  status: '',
  produto_search: '',
  descricao_search: '',
  familia_id: '',
  tipo_filter: ''
})





// Filter options from metadata
const statusOptions = ref([])
const familiaOptions = ref([])




// Computed
const hasActiveFilters = computed(() => {
  return Object.values(filters.value).some(value => value !== '' && value !== null && value !== undefined)
})

// Handle filter changes
const onFilterChange = () => {
  applyFilters()
}


// Load filter metadata
const loadMetadata = async () => {
  try {
    const response = await axios.get(`${process.env.VUE_APP_URL_BASE}/api/v1/produto/metadata/`)
    const metadata = response.data.data
    // console.log('LocalInstalacao Metadata:', metadata)

    // Extract options from metadata
    if (metadata.filters) {
      metadata.filters.forEach(filter => {
        if (filter.key === 'status') {
          let statusOpts = filter.options || []
          // Filter status options if allowedStatuses prop is provided
          if (props.allowedStatuses && props.allowedStatuses.length > 0) {
            statusOpts = statusOpts.filter(opt => props.allowedStatuses.includes(opt.value))
          }
          statusOptions.value = statusOpts
        } else if (filter.key === 'familia_id') {
          familiaOptions.value = filter.options || []
        }
      })
    }
  } catch (error) {
    console.error('Error loading subcliente metadata:', error)
  }
}

// Apply filters
const applyFilters = () => {
  // Create a copy of filters to process
  const filtersToSend = { ...filters.value }
  

  
  // Remove empty values
  const activeFilters = Object.fromEntries(
    Object.entries(filtersToSend).filter(([, value]) => value !== '' && value !== null)
  )

  // If no status filter is set and defaultStatus is provided, use the default
  if (!activeFilters.status && props.defaultStatus) {
    activeFilters.status = props.defaultStatus
  }

  // Add backend restriction parameter if provided
  if (props.restrictToStatuses && props.restrictToStatuses.length > 0) {
    activeFilters.restrict_status = props.restrictToStatuses.join(',')
  }

  emit('filtersChanged', activeFilters)
}

// Clear filters
const clearFilters = () => {
  filters.value = {
    status: '',
    produto_search: '',
    descricao_search: '',
    familia_id: '',
    tipo_filter: ''
  }
  emit('filtersChanged', {})
}

// Close filter
const closeFilter = () => {
  emit('close-filter')
}

onMounted(() => {
  loadMetadata()
})
</script>

<style scoped>
.filter-group {
  @apply flex flex-col space-y-1;
}

.filter-label {
  @apply text-sm font-medium text-gray-300;
}

.filter-input {
  @apply bg-[var(--fundoForm)] border border-gray-600 rounded px-3 py-2 text-[var(--text)] text-sm;
  @apply focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500;
}

.filter-input:focus {
  @apply bg-opacity-80;
}

.negocio-filter-container {
  @apply border border-gray-700;
}
</style>

